import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { initValidation } from "@/helpers/Validation";
import { initAxios } from "@/helpers/axios";
import vuetify from "./plugins/vuetify";
import autoIdQueries from "@/mixins/autoIdQueries";
import loader from "@/mixins/loader-mixin";
import "@/style/scss/style.scss";
import "@/style/scss/adaptive.scss";
import * as Sentry from "@sentry/vue";
import VueCookies from "vue-cookies";

import moment from "moment";
import "moment/locale/ru";

import phoneFilter from "@/helpers/filters/phoneFilter";
import numberRounded from "@/helpers/filters/numberRounded";

import momentDurationFormatSetup from "moment-duration-format";

import mitt from "mitt";
import { mask } from "vue-the-mask";

const app = createApp(App);

console.log(`App revision: ${process.env.VUE_APP_GIT_HASH}`);
app.config.globalProperties.$leftJoin = function (
  objArr1,
  objArr2,
  key1,
  key2,
) {
  return objArr1.map((anObj1) => ({
    ...objArr2.find((anObj2) => anObj1[key1] === anObj2[key2]),
    ...anObj1,
  }));
};

app.config.globalProperties.$filters = {
  phone: phoneFilter.execute,
  numberRounded: numberRounded.execute,
};

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [process.env.VUE_APP_BASE_URL],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NODE_ENV,
    release: process.env.VUE_APP_GIT_HASH,
  });
}

momentDurationFormatSetup(moment);
moment.locale("ru");

app.config.globalProperties.$events = mitt();
app.config.globalProperties.$cookies = VueCookies;

app.config.globalProperties.$append = (path, pathToAppend) => {
  const basePath = path.endsWith("/") ? path.slice(0, -1) : path;
  return `${basePath}/${pathToAppend}`;
};

app.mixin(autoIdQueries);
app.mixin(loader);

initValidation();
initAxios();

app.directive("mask", mask);

app.use(router).use(store).use(vuetify).mount("#app");
